import { reconciliationActionTypes as actions } from '~constants/actionTypes';
import { fetch } from '~actions/shared';
import { get, compact } from 'lodash';
import endpoints from '~settings/endpoints';
import { formatSimpleParams } from '~helpers/params';
import * as queries from '~settings/queries';
import { message } from 'antd';
import { sortByMapping } from '~constants';
import i18n from '~settings/i18n';
import * as reconciliationQueries from './queries';
import { dayFormatType, isBefore, moment } from '~helpers/day';

export const setListReconciliationLandlords = payload => ({
  type: actions.SET_LIST_RECONCILIATION_LANDLORDS,
  payload,
});

export const listReconciliationLandlords = params => dispatch => {
  const newParam = { ...params };
  if (
    newParam.completedAtStart &&
    isBefore(moment().subtract(1, 'year').startOf('year'), newParam.completedAtStart)
  ) {
    newParam.completedAtStart = moment().startOf('year').format(dayFormatType.APIPARAMS);
  }

  if (
    newParam.completedAtEnd &&
    isBefore(moment().subtract(1, 'year').startOf('year'), newParam.completedAtEnd)
  ) {
    newParam.completedAtEnd = moment().endOf('month').format(dayFormatType.APIPARAMS);
  }

  fetch({
    dispatch,
    endpoint: endpoints.defaultUrl.url(),
    params: queries.listReconciliationLandlords(
      formatSimpleParams(
        {
          pageNumber: 1,
          pageSize: 10,
          completedAtEnd: moment().endOf('month').format(dayFormatType.APIPARAMS),
          completedAtStart: moment().startOf('year').format(dayFormatType.APIPARAMS),
          orderReferenceId: null,
          landlordIds: null,
          billingCountry: [],
          reconciliationOption: null,
        },
        newParam,
      ),
    ),
    communicationType: actions.GET_LIST_RECONCILIATION_LANDLORDS_CS,
    successAction: setListReconciliationLandlords,
    onError: () => {
      message.error(i18n.t('cms.properties.edit.toast.error'));
    },
  });
};

export const listOpportunityReconciliation = params => dispatch => {
  fetch({
    dispatch,
    endpoint: endpoints.defaultUrl.url(),
    params: queries.listOpportunityReconciliation(params),
    communicationType: actions.GET_LIST_OPPORTUNITY_RECONCILIATION_CS,
    successAction: payload => ({
      type: actions.GET_LIST_OPPORTUNITY_RECONCILIATION,
      payload,
    }),
    onError: () => {
      message.error(i18n.t('cms.properties.edit.toast.error'));
    },
  });
};

// export const exportListOpportunityReconciliation = params => {
//   fetch({
//     endpoint: endpoints.defaultUrl.url(),
//     params: queries.listOpportunityReconciliation(params),
//     communicationType: actions.GET_LIST_OPPORTUNITY_RECONCILIATION_CS,
//     successAction: payload => ({
//       type: actions.GET_LIST_OPPORTUNITY_RECONCILIATION,
//       payload,
//     }),
//     onError: () => {
//       message.error(i18n.t('cms.properties.edit.toast.error'));
//     },
//   });
// };

export const getReconciliationBulkUpdateRecords = params => dispatch => {
  const newParam = { ...params };
  fetch({
    dispatch,
    endpoint: endpoints.defaultUrl.url(),
    params: reconciliationQueries.listReconciliationBulkUpdateRecords(
      formatSimpleParams(
        {
          pageNumber: 1,
          pageSize: 10,
          originalFilename: null,
          status: null,
          updatedByUuids: null,
          sortBy: sortByMapping.createdAt,
        },
        newParam,
      ),
    ),
    communicationType: actions.GET_LIST_RECONCILIATION_BULK_UPDATE_RECORDS_CS,
    successAction: payload => ({
      type: actions.SET_LIST_RECONCILIATION_BULK_UPDATE_RECORDS,
      data: {
        payload: get(payload, ['listReconciliationBulkUpdateRecords', 'edges']).map(record => {
          const bulkUpdateRecord = record.node;
          const fullName = [];

          const firstName = get(bulkUpdateRecord, ['cmsUser', 'firstName'], '');
          const lastName = get(bulkUpdateRecord, ['cmsUser', 'lastName'], '');
          fullName.push(firstName);
          fullName.push(lastName);
          bulkUpdateRecord.cmsUser = compact(fullName).join(' ');

          return bulkUpdateRecord;
        }),
        total: get(payload, ['listReconciliationBulkUpdateRecords', 'totalCount']),
      },
    }),
    onError: () => {
      message.error(i18n.t('cms.properties.edit.toast.error'));
    },
  });
};

export const searchLandlordList =
  (value, successCallback = () => {}) =>
  dispatch => {
    const query = queries.searchLandlordList({
      pageNumber: 1,
      pageSize: 100,
      query: value,
      publishedStatus: 'ALL',
    });
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: query,
      communicationType: actions.LANDLORD_LIST_CS,
      onSuccess: res => {
        successCallback(res);
      },
    });
  };

export const searchPropertyList =
  (value, successCallback = () => {}) =>
  dispatch => {
    const query = queries.searchProperty({
      pageNumber: 1,
      pageSize: 100,
      query: value,
    });
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: query,
      communicationType: actions.PROPERTY_LIST_CS,
      onSuccess: res => {
        successCallback(res);
      },
    });
  };

export const searchCountryList =
  (value, successCallback = () => {}) =>
  dispatch => {
    const query = queries.searchCountry({
      pageNumber: 1,
      pageSize: 100,
      query: value,
      bookingJourneys: ['LEAD_GENERATION'],
    });
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: query,
      communicationType: actions.COUNTRY_LIST_CS,
      onSuccess: res => {
        successCallback(res);
      },
    });
  };

export const searchCityList =
  (value, successCallback = () => {}) =>
  dispatch => {
    const query = queries.searchCity({
      pageNumber: 1,
      pageSize: 100,
      query: value,
      bookingJourneys: ['LEAD_GENERATION'],
    });
    fetch({
      dispatch,
      endpoint: endpoints.defaultUrl.url(),
      params: query,
      communicationType: actions.CITY_LIST_CS,
      onSuccess: res => {
        successCallback(res);
      },
    });
  };
